import { render, staticRenderFns } from "./LocationsList.vue?vue&type=template&id=22742a80"
import script from "./LocationsList.vue?vue&type=script&lang=js"
export * from "./LocationsList.vue?vue&type=script&lang=js"
import style0 from "./LocationsList.vue?vue&type=style&index=0&id=22742a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports